import React from "react";

interface FloatingSocialBarProps {
  onOpenGuestbook?: () => void;
}

const FloatingSocialBar: React.FC<FloatingSocialBarProps> = () => {
  return (
    <div className="fixed bottom-8 left-8 z-50 flex flex-col gap-3">
    </div>
  );
};

export default React.memo(FloatingSocialBar);